import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    width: '360px',
    maxWidth: '90vw',
    background: theme.palette.custom.background.area,
    padding: theme.spacing(6, 3, 3, 3),
    borderRadius: theme.shape.borderRadiusLarge,
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',

    '& .logo': {
      '&-container': {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: theme.spacing(4),
      },

      '&-img': {
        maxWidth: 180,
        maxHeight: theme.spacing(9),
        objectFit: 'contain',
        margin: `0 auto ${theme.spacing(2)}px`,
      },
    },

    '& .description': {
      '&-container': {
        marginBottom: theme.spacing(2),
      },

      '&': {
        color: theme.palette.text.secondary,
      },
    },

    '& .input': {
      '&-container': {
        display: 'flex',
        flexDirection: 'column',

        '&.email': {
          marginBottom: theme.spacing(3),
        },
      },

      '&': {
        display: 'flex',
      },
    },

    '& .btn-recovery': {
      '&-container': {
        display: 'flex',
        flexDirection: 'column',
      },

      '&': {
        marginBottom: theme.spacing(1),
      },
    },

    '& .btn-back': {
      '&-container': {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(3),
      },
    },
  },
}));

export default styles;
